import React from 'react'
import { connect } from 'react-redux'
import { Typography, List, ListItem, ListItemText } from '@material-ui/core';
import { NavHashLink } from 'react-router-hash-link';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    sidebar: {
        position: "sticky",
        top: "100px",
        width: '80%'
    },
    list: {
        borderRadius: '4px',
        height: '100%',
        overflowY: 'auto'
    },
    link: {
        textTransform: 'capitalize',
        textDecoration: "none",
        color: theme.palette.primary.main,
        '&:hover': {
            '& >li>div>*': {
                fontSize: '20px',
                borderBottom: `2px solid ${theme.palette.secondary.main}`
            }
        }
    },
    active: {
        '& >li>div>*': {
            fontSize: '20px',
            borderBottom: `2px solid ${theme.palette.secondary.main}`
        }

    }

}));

const CategoryList = (props) => {
    const classes = useStyles();
    const { categoryData } = props

    return (
        <div className={classes.sidebar} >
            <List aria-label="Category Table" className={classes.list} >
                {
                    categoryData.map(cat => {
                        return (
                            <NavHashLink smooth to={`#${cat.id}`} key={cat.id} className={classes.link} activeClassName={classes.active}>
                                <ListItem >
                                    <ListItemText primary={<Typography component="span" variant="body1">{cat.label.toLowerCase()}</Typography>} />
                                </ListItem >
                            </NavHashLink>
                        )
                    })
                }
            </List>
        </div>

    )
}

const mapStateToProps = (state) => {
    const categories = state.categories
    const categoryData = []

    for (let key in categories) {
        if (categories[key].items.length > 0) {
            categoryData.push(categories[key])
        }
    }

    return { categoryData }
}

export default connect(mapStateToProps, {})(CategoryList)
